import { fetchApi } from '@/config/axiosSetting';
import { PatchCulpritVehicleInformationAfterInquiryType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchCulpritVehicleInformationAfterInquiry/patchCulpritVehicleInformationAfterInquiry.type';

export const patchCulpritVehicleInformationAfterInquiryFunction = ({
  id,
  data,
}: PatchCulpritVehicleInformationAfterInquiryType) => {
  return fetchApi.patch(
    `/property/reports/${id}/accident_users/culprit/vehicle_information/`,
    {
      ...data,
      id,
    },
  );
};
